// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../fonts/helvetica_bold_oblique.ttf");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../fonts/helvetica_light_oblique.ttf");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "body,dl,dd,dt,p,h1,h2,h3,h4,h5,h6{font-family:'Helvetica','element-icons', sans-serif}body{margin:0}@font-face{font-family:Helvetica-BoldOblique;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}@font-face{font-family:Helvetica-LightOblique;src:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
